// Rivanta — slider do cartão, filtro por coleção e ordenação da grade de produtos
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.collection-grid-section').forEach(function (grid) {

    // --- slider de imagens de cada cartão (arraste e toque) ---
    grid.querySelectorAll('.product-slider').forEach(function (slider) {
      var wrapper = slider.querySelector('.product-slider-wrapper');
      var slides = slider.querySelectorAll('.product-slide');
      var card = slider.closest('.product-card');
      var dots = card ? card.querySelectorAll('.dot') : [];
      if (slides.length <= 1) return;

      var currentSlide = 0;

      function updateDots() {
        dots.forEach(function (dot, i) {
          dot.classList.toggle('active', i === currentSlide);
        });
      }
      function updateSlider() {
        wrapper.style.transform = 'translateX(-' + (currentSlide * 100) + '%)';
        updateDots();
      }

      dots.forEach(function (dot, i) {
        dot.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          currentSlide = i;
          updateSlider();
        });
      });

      var touchStartX = 0, touchEndX = 0;
      slider.addEventListener('touchstart', function (e) { touchStartX = e.changedTouches[0].screenX; }, { passive: true });
      slider.addEventListener('touchend', function (e) {
        touchEndX = e.changedTouches[0].screenX;
        var threshold = 50;
        if (touchStartX - touchEndX > threshold) { currentSlide = Math.min(currentSlide + 1, slides.length - 1); updateSlider(); }
        else if (touchEndX - touchStartX > threshold) { currentSlide = Math.max(currentSlide - 1, 0); updateSlider(); }
      }, { passive: true });

      var isDragging = false, startPosX = 0;
      slider.addEventListener('mousedown', function (e) {
        e.preventDefault();
        isDragging = true;
        startPosX = e.clientX;
        slider.style.cursor = 'grabbing';
      });
      slider.addEventListener('mousemove', function (e) {
        if (!isDragging) return;
        e.preventDefault();
        var moveX = e.clientX - startPosX;
        var slideWidth = slider.offsetWidth;
        if (Math.abs(moveX) < slideWidth * 0.5) {
          wrapper.style.transform = 'translateX(' + (-currentSlide * 100 + (moveX / slideWidth * 100)) + '%)';
        }
      });
      document.addEventListener('mouseup', function (e) {
        if (!isDragging) return;
        isDragging = false;
        slider.style.cursor = 'grab';
        var moveX = e.clientX - startPosX;
        var threshold = slider.offsetWidth * 0.2;
        if (moveX < -threshold) currentSlide = Math.min(currentSlide + 1, slides.length - 1);
        else if (moveX > threshold) currentSlide = Math.max(currentSlide - 1, 0);
        updateSlider();
      });
      document.addEventListener('mouseleave', function () {
        if (isDragging) { isDragging = false; slider.style.cursor = 'grab'; updateSlider(); }
      });

      updateDots();
    });

    // --- filtro por coleção (clique nas abas) ---
    var collectionLinks = grid.querySelectorAll('.collection-filter-link');
    var productCards = grid.querySelectorAll('.product-card');

    collectionLinks.forEach(function (link) {
      link.addEventListener('click', function (e) {
        e.preventDefault();
        collectionLinks.forEach(function (l) { l.classList.remove('active'); });
        this.classList.add('active');
        var collectionHandle = this.getAttribute('data-collection');
        productCards.forEach(function (card) {
          var cardCollections = card.getAttribute('data-collection') || '';
          var shouldShow = collectionHandle === 'all' || (' ' + cardCollections + ' ').indexOf(' ' + collectionHandle + ' ') !== -1;
          card.style.display = shouldShow ? '' : 'none';
        });
      });
    });

    // --- ordenação ---
    var sortSelect = grid.querySelector('.sort-by-dropdown select');
    if (sortSelect) {
      sortSelect.addEventListener('change', function () {
        var selectedSort = this.value;
        var productGrid = grid.querySelector('.product-grid');
        var visibleProducts = Array.prototype.filter.call(productCards, function (card) { return card.style.display !== 'none'; });

        visibleProducts.sort(function (a, b) {
          switch (selectedSort) {
            case 'price-ascending': return parseFloat(a.getAttribute('data-price')) - parseFloat(b.getAttribute('data-price'));
            case 'price-descending': return parseFloat(b.getAttribute('data-price')) - parseFloat(a.getAttribute('data-price'));
            case 'title-ascending': return a.getAttribute('data-title').localeCompare(b.getAttribute('data-title'));
            case 'title-descending': return b.getAttribute('data-title').localeCompare(a.getAttribute('data-title'));
            case 'created-ascending': return parseInt(a.getAttribute('data-created'), 10) - parseInt(b.getAttribute('data-created'), 10);
            case 'created-descending': return parseInt(b.getAttribute('data-created'), 10) - parseInt(a.getAttribute('data-created'), 10);
            default: return parseInt(a.getAttribute('data-index'), 10) - parseInt(b.getAttribute('data-index'), 10);
          }
        });

        visibleProducts.forEach(function (product) { productGrid.appendChild(product); });
      });
    }
  });
});
